var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box"},[_vm._t("default"),_c('div',[_c('ds-text-button',{staticClass:"error-box-retry-button",attrs:{"leading-icon":"refresh-cw"},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._t("retry",function(){return [_vm._v(" Try again ")]})],2)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }